module.exports = __webpack_public_path__ + "static/media/ripple.e464cf62.gif";